import { BookmarkIconButton } from "@/components/core/inputs/BookmarkIconButton";
import { useBookmark } from "hooks/useBookmark";
import { ComponentProps } from "react";

export const ContentBookmark = ({
    variant,
    content,
    className,
    ...props
}: Omit<
    ComponentProps<typeof BookmarkIconButton>,
    "checked" | "onClick" | "content"
> & {
    content: Mix_ContentFragment;
}) => {
    const { toggle } = useBookmark(content);

    return (
        <div
            className={className}
            onClick={(e) => {
                e.stopPropagation(); // prevent bubbling when bookmark clicked
            }}
        >
            <BookmarkIconButton
                variant={variant}
                checked={!!content.bookmarked}
                onChange={toggle}
                {...props}
            />
        </div>
    );
};
